var allPanel = {
    Products: {
        showFilters: true,
        showHighLevel: true
    },
    Apps: {
        showFilters: true,
        showHighLevel: true
    },
    Categories: {
        showFilters: true,
        showImages: true
    },
    Industries: {
        showFilters: true,
        divideLevel: true,
        showImages: true
    },
    'Consulting Services': {
        showFilters: true
    },
    'Professional Services': {
        showFilters: true
    },
    Partners: {
        showHighLevel: true
    }
};

export { allPanel };
